import * as THREE from 'three';
import {
  ThreeViewBase, defines, SystemEnv, Scene, events, ItemManager, Renderer, Cameras, WalkThroughCameraControls, WalkThroughCameraControl, CameraControlType, CanvasInfo, Camera, CameraControl, OrbitCameraControl, mesUtils, MessageType, WalkThroughAnimation,
} from '../base/index';
import {
  WebCadItemManager, WebCadDimensionLine, webcadcamera, WebCadScene, WebCadRenderer, MaterialManager, WebCadMenus, WebCadDevelop, webcadDefines, View3dGlobal, PixelStreamingView, PSSceneManagement
} from '../webcad';
import * as marietta from '../..';
import * as marietta3d from '../../../marietta3d';
import * as pscommand from '../../pixelstreaming/commands';
import * as network from '../../pixelstreaming/network';
import * as PSGUI from '../../pixelstreaming/GUI'

import { VectorUtility } from '../../graphicLibs/utility/vectorUtility';

import { SceneExtras } from './sceneExtras';
import { PickerManager } from './picker/PickerManager';
import { ItemDragManager, ObjectSelectManager } from './ItemDrag';
import { MeasureManager } from './MeasureManager';

import { ExportCollada } from './exporter/ExportCollada';
import { ExportGLTF } from './exporter/ExportGLTF';
import { BBOXManager } from './BBOXManager';
import { OctreeManager } from './Octree/OctreeManager';
import { CameraTarget } from './Octree/CameraTarget';

import PSInteractiveView from './View3dWebCadPSInteractive';
import { R2MConnect } from './R2MConnect';
import { View3dController } from './View3dController';
import { SelectManager } from './SelectManager';
import { wallEffect } from './material/wallEfeect';

import { LoadJSON } from '../../LiDAR/commands/LoadJSON';
import { Convert, JSONParse } from '../../LiDAR/jsonParse';
import { LiDARUnitBath } from '../../network/LiDARUnitBath';
import { ObjectType } from './ObjectType';

import * as edit from './commands'
import { LeftMenuChangeColor } from './material/LeftMenuChangeColor';
import { BuildingDocument, CorrectionManager } from '../../LiDAR/commands';
import * as roomMaterial from './material';
import { WizardManager } from '../../webcad/view/dialog';

import { CameraPinManager } from './cameraPin/CameraPinManager';
import { Fitting } from '../../webcad/item';
import { ItemInfoCollection } from '../../webcad/collection';
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO, MM_PER_M } from '../../webcad/Constants';
import { CommonInfoData, FreeTextInfoData } from '../../webcad/util/WebcadJSONExporter';
import { MeasureTool } from './MeasureTool';
import { ModelLoadSystem } from './WebCad3dModelLoadSystem';
import { WebViewData } from '../../network/WebViewData';

/** ダウンロード用に作ったURLを解放するまでの待ち時間（ミリ秒） */
const OBJECT_URL_REVOKE_DELAY_MS = 1000;

/* ThreeView
 * WebCAD用.
 */
export class ThreeView extends ThreeViewBase {
    protected static _instance: ThreeView = undefined;

    static get(container?: HTMLElement, params?: {}): ThreeView {
      if ((ThreeView._instance === undefined) && (container !== null)) {
        new ThreeView(container, params);
      }
      return ThreeView._instance;
    }

    // イニシャライズが完了したら
    static exist(): boolean { return ThreeView._instance != undefined; }

    // 各種データ管理.
    public get wcItemmgr(): WebCadItemManager { return <WebCadItemManager>(this.itemmgr); }

    private _sunpou: WebCadDimensionLine;

    public get wcSunpou(): WebCadDimensionLine { return this._sunpou; }

    public get wcCameras(): webcadcamera.WebCadCameras { return <webcadcamera.WebCadCameras>(this.cameras); }

    public get wcScene(): WebCadScene { return <WebCadScene>(this.scene); }

    public get wcRenderer(): WebCadRenderer { return <WebCadRenderer>(this.renderer); }

    private _materialmgr: MaterialManager;

    public get matmgr(): MaterialManager { return this._materialmgr; }

    //picker
    public pickermanager: PickerManager;

    // 3Dメジャー
    public measuremanager: MeasureManager;

    // 3Dメジャーツール
    public measureTool: MeasureTool | null;

    // 3Dメジャー
    public cameraPinManager: CameraPinManager;

    // 家データ管理.
    private _planmgr: marietta3d.manager.AutoMain;

    public get planmgr(): marietta3d.manager.AutoMain { return this._planmgr; }

    // メニュー処理.
    private _menus: WebCadMenus;

    public get menus(): WebCadMenus { return this._menus; }

    // メッセージ.
    private _message: string;

    public pscommunication: network.communication | network.R2MCommunication;

    public leftMenuMaterial: LeftMenuChangeColor;
    public selectManager: SelectManager;
    public ItemDragManager: ItemDragManager;
    public ObjectSelectManager: ObjectSelectManager;
    public BBOXSelectedManager: BBOXManager;
    public OctreeManager: OctreeManager;
    public CameraTarget: CameraTarget;

    public controller: View3dController;

    //部位の強調表示
    public wallEffect: wallEffect;

    //PixelStreaming
    public PSImageView:PixelStreamingView;
    public r2mconnect : R2MConnect;

    public LidarManager: LoadJSON;
    public correctionManager: CorrectionManager;
    public wizardManager: WizardManager;
    public buildingDocument: BuildingDocument;

    public interactiveView:PSInteractiveView;

    public logger:network.logger;

    public R2MSupport: boolean;

    public isPSVideoMode: boolean;

    public isOpenDialog: boolean = false;       // ダイアログが開いているか
    public isOperation: boolean = false;        // 形状の移動、配置中
    public isFocusText: boolean = false;        // 吹き出しのテキストにフォーカスが当たっているか
    // 操作モード
    public set opeMode(mode: defines.OpeMode) {
      this.wcCameras.opeMode = mode;
      this.menus.opeMode = mode;
      this.matmgr.opeMode = mode;
    }

    // 表示状態
    public get visible(): boolean {
      return (marietta.webcad.WebCADGlobal.dimensionMenu != undefined)
            && (marietta.webcad.WebCADGlobal.dimensionMenu.mode != undefined)
            && (marietta.webcad.WebCADGlobal.dimensionMenu.mode == '3D');
    }

    // 日付/場所設定
    private _dayTime: string;

    public get dayTime(): string { return this._dayTime; }

    public set dayTime(dayTime: string) {
       this._dayTime = dayTime;
    }

    private _placeData: { longitude: number, latitude: number, timezone: number };

    public get placeData(): { longitude: number, latitude: number, timezone: number } { return this._placeData; }

    public set placeData({ longitude, latitude, timezone }) {
       this._placeData = { longitude, latitude, timezone };
    }

    // ライト設定
    private _lightSetting: { intensity: number, temperature: number };

    public get lightSetting(): { intensity: number, temperature: number } { return this._lightSetting; }

    public set lightSetting({ intensity, temperature }) {
       this._lightSetting = { intensity, temperature };
    }


    // 開発用
    public get wcDevelop(): WebCadDevelop { return <WebCadDevelop>(this.develop); }

    /*
     * コンストラクタ
     */
    constructor(container?: HTMLElement, params?: {}) {
      super(container, params);
      ThreeView._instance = this;
      this.eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.initialized);
    }

    /* initialize
     * 初期化
     */
    protected initialize(): void {
      // Shared Managerの初期化.
      this.initConstants();
      View3dGlobal.init_shared(this.params);
      View3dGlobal.shared.local = SystemEnv.islocalhost;

      // 各種データ管理オブジェクト.
      this._materialmgr = new MaterialManager();
      this.leftMenuMaterial =new LeftMenuChangeColor();

      super.initialize();

      this._sunpou = new WebCadDimensionLine();

      this.controller = new View3dController();

      this.pickermanager = new PickerManager();
      this.measuremanager = new MeasureManager();

      this.cameraPinManager = new CameraPinManager();

      this.CameraTarget = new CameraTarget();

      this.resetOpacity(false);

      this.wcRenderer.posteffect = true; // start with true.
      this.wcRenderer.matmgr = this._materialmgr;

      this.initPixelStreaming();
      // UE5の環境設定の初期化
      const placeData = new pscommand.placeDateStatus().object().data;
      const date = new Date();
      this.dayTime = `${date.getFullYear()}/${(date.getMonth() + 1)}/${date.getDate()} 9:00`;
      this.placeData = { longitude: placeData.longitude, latitude: placeData.latitude, timezone: placeData.timezone };
      const lightSetting = new pscommand.lightSetting().object().data;
      this.lightSetting = { intensity: lightSetting.intensity, temperature: lightSetting.temperature };
      // 開発用.
      if (marietta.WebCADGlobal.DEBUG_MODE) this._develop = new WebCadDevelop(this);
      //
      this.wallEffect = new wallEffect();

      this.initMeasureTool();
    }

    private initMeasureTool() {

      document.getElementById('btneMesure').addEventListener('click', () => {
        const isNaikan = ThreeView.get().cameras.isWalkThroughCameraMode();
        if (!isNaikan) return;

        this.closeRightMenu();
        marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();    // 表示中の左メニューを閉じる
        ThreeView.get().unSelectedObject();

        this.measureTool = new MeasureTool();

        ThreeView.get().selectManager.invalidate = true;        //選択無効
        this.measureTool.measureMode();

      });
    }

    private initPixelStreaming() {
        this.isPSVideoMode = false;
        this.setPSServer(true);
    }

    public setPSServer(isR2M: boolean) {
        this.R2MSupport = isR2M;

        const Server = isR2M ? network.R2MCommunication : network.communication;
        this.pscommunication = new Server();

        this.r2mconnect = new R2MConnect();

        this.logger = new network.logger();
        this.pscommunication.addReceiver(this.logger);

        this.PSImageView = new PixelStreamingView(this._container);
        this.pscommunication.addReceiver(this.PSImageView);

        this.interactiveView = new PSInteractiveView(this._container);
        this.pscommunication.addReceiver(this.interactiveView);

        const scenemanagement = new PSSceneManagement();
        this.pscommunication.addReceiver(scenemanagement);      // PS接続時にシーンを送信

        const button = new PSGUI.renderingButton();
        this.pscommunication.addReceiver(button);

        const timer = new network.Timer();
        this.pscommunication.addReceiver(timer);
    }

    //ウィンドウのサイズ変更
    onScreenSizeChange = () =>{
    //   if(ThreeView.get().streamingView) ThreeView.get().streamingView.updateCanvasSize();
      if(ThreeView.get().interactiveView) ThreeView.get().interactiveView.updateCanvasSize();
    }

    protected initConstants(): void {
      // to evade server compilation error.
      webcadDefines.WebCadCameraDefs.turnAxis = new THREE.Vector3(0, 1, 0);
      webcadDefines.WebCadCameraDefs.centerPos = new THREE.Vector3(0, 0, 0);
      webcadDefines.WebCadCameraDefs.initShowPos = new THREE.Vector3(-10.0*0.4, 2.0, 22.0*0.4);
      webcadDefines.WebCadCameraDefs.initOrbitPos = new THREE.Vector3(-1200, 600, 500).multiplyScalar(0.02);
      webcadDefines.WebCadCameraDefs.initWlkThPos = new THREE.Vector3(0, 1.4, 5);
      webcadDefines.WebCadCameraDefs.initWlkThTgt = new THREE.Vector3(0, 1.4, 0);
      webcadDefines.WebCadCameraDefs.floorViewPos = new THREE.Vector3(0, 0, 3.2);
    }

    /* createScene(override)
    * シーンの準備.
    */
    protected createScene(): Scene {
      return new WebCadScene();
    }

    /* createItemManager(override)
     * アイテムの管理の作成.
     */
    protected createItemManager(scene: Scene, eventDispatcher: events.EventDispatcher): ItemManager {
      return new WebCadItemManager(scene, eventDispatcher);
    }

    /* createRenderer(override)
     * レンダラの作成.
     */
    protected createRenderer(container: HTMLElement): Renderer {
      return new WebCadRenderer(container);
    }

    /* setupCameras(override)
     * カメラコントロールの作成.
     */
    protected createCameraManager(eventDispatcher: events.EventDispatcher): Cameras {
      return new webcadcamera.WebCadCameras(eventDispatcher);
    }

    // オービットカメラの作成.(no==0)
    private createOrbitCamera() {
        const { size } = CanvasInfo.get();
        const aspect = size.x / size.y;

        const camera = new webcadcamera.WebCadPerspectiveCamera(this.wcItemmgr, 64, aspect, 0.01, 600, this.cameras);
        camera.position = webcadDefines.WebCadCameraDefs.initOrbitPos.clone();
        // camera.setLens(52, 35);
        camera.control = this.createOrbitCameraControl(camera);
        camera.addNavigator(new webcadcamera.WebCadPicker(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadMeasure3D(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadPinPicture(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadSelectedBBOX(this.eventDispatcher));
        camera.uiEnabled = false;
        this.cameras.add(camera, true);
    }

    // ウォークスルーカメラの作成.(no==1)
    private createWalkThroughCamera() {
        const { size } = CanvasInfo.get();
        const aspect = size.x / size.y;

        // pixelstreaming用カメラの画角算出
        const hFOV = 96; // desired horizontal fov, in degrees
        const vfov = Math.atan( Math.tan( hFOV * Math.PI / 360 ) / aspect ) * 360 / Math.PI; // degrees

        const camera = new webcadcamera.WebCadWtPerspectiveCamera(this.wcItemmgr, vfov, aspect, 0.01, 550, this.cameras);
        camera.position = webcadDefines.WebCadCameraDefs.initWlkThPos.clone();
        camera.control = this.createWalkThroughCameraControl(camera);
        camera.addNavigator(new webcadcamera.mantionMove(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WalkThroughCameraNavigator(this.container, this.eventDispatcher));
        camera.addNavigator(new WalkThroughCameraControls(this.container, <WalkThroughCameraControl>(camera.control), this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadPicker(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadMeasure3D(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadPinPicture(this.eventDispatcher));
        camera.addNavigator(new webcadcamera.WebCadSelectedBBOX(this.eventDispatcher));
        this.cameras.add(camera, false);
    }

    /* createCameraControl(override)
     * ウォークスルーカメラコントロールの作成.
     */
    private createWalkThroughCameraControl(camera: Camera): CameraControl {
        const control = new WalkThroughCameraControl(camera, this.container, this.eventDispatcher);
        control.me.setMoveSpeed(2);
        control.me.setMoveSpeedForTouch(0.05);
        control.me.setRotSpeed(2);
        control.me.setHitMargin(0.33);
        control.me.setHitteHeightOfset(-camera.position.y * 0.70); // base に当らない高さに.
        control.me.setWheelReverse(true);
        return control;
    }

    /* createCameraControl(override)
     * オービットカメラコントロールの作成.
     */
    private createOrbitCameraControl(camera: Camera): CameraControl {
        const control = new OrbitCameraControl(camera, this.container, this.eventDispatcher);
        control.me.enabled = false;     // 初期状態でdisableに
        control.me.minDistance = 6;     // カメラ最小距離
        control.me.maxDistance = 25;    // カメラ最大距離   //
        control.me.keyPanSpeed = 0.2; 	// パンの速度
        control.me.rotateSpeed = 0.75; 	// 回転の速度
        // 最大回転角（ラジアン値）
        if (!SystemEnv.islocalhost) {
            control.me.maxPolarAngle = Math.PI * 0.49;
        }
        control.me.target = new THREE.Vector3(0.0, webcadDefines.WebCadCameraDefs.orbitHeight, 0.0); // 目の高さあたりに

        control.me.addEventListener('change', () => {
            if (!control.enabled) return;
            if (!ThreeView._instance) return;
            const sizes = ThreeView.get().wcItemmgr.sizesObjects;       // 寸法線
            if (sizes && sizes.visible) {
                sizes.update(control.me.object.getWorldDirection(new THREE.Vector3()));
            }
            //カメラ移動情報をPSに送信
            new PSSceneManagement().sendCamera();
        });

        control.me.addEventListener('start', () => {
            //カメラ操作時に形状選択の解除
            // ThreeView.get().unSelectedObject();
        });

        control.me.addEventListener('end', () => {
            //カメラ移動情報をPSに送信
            new PSSceneManagement().sendCamera();
            // 画角内判定
            ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

        });
        return control;
      }

    /* createCameras(override)
     * カメラコントロールの作成.
     */
    public createCameras(): void {
        this.createOrbitCamera();
        this.createWalkThroughCamera();
    }

    /* createCameraControl(override)
     * カメラコントロールの作成.
     */
    public createCameraControl(camera: Camera, controlType?: CameraControlType): CameraControl {
        if (controlType == CameraControlType.WalkThrough) {
            return this.createOrbitCameraControl(camera);
        }
        return this.createWalkThroughCameraControl(camera);
    }

    /* cameraController
     * カメラのコントロール
     */
    public cameraController = (flag: boolean) => {
      const camNo = ThreeView.get().wcCameras.isWalkThroughCameraMode() ? defines.CameraDefs.wlkthCamNo : defines.CameraDefs.orbitCamNo;
      const camera = ThreeView.get().wcCameras.getCamera(camNo);
      if (camNo == defines.CameraDefs.wlkthCamNo) (<WalkThroughCameraControl>camera.control)._instance.setEnabled(flag);
      if (camNo == defines.CameraDefs.orbitCamNo) (<OrbitCameraControl>camera.control).setEnabled(flag);
    };

    /* openDialog
     * ダイアログを開いた際のコールバック
     */
    public openDialog(): void {
      ThreeView.get().cameraController(false);
    }

    /* closeDialog
     * ダイアログを閉じた際のコールバック
     */
    public closeDialog(): void {
      ThreeView.get().unSelectedObject();
      this.isOpenDialog = false;
    }

    /* setupMisc
    * その他のセットアップ
    */
    protected setupMisc() {
      this._menus = new WebCadMenus(this.eventDispatcher);
    }

    public RoomSelector() {

      const select = (e) => {
          // if (ThreeView.get().isPSVideoMode && ThreeView.get().isShowUE == false) return; // 起動画面表示時
          // if (marietta.WebCADGlobal.userAgentManager.isMobile) return;
          // if (ThreeView.get().isFullscreen) return;

          // if (ThreeView.get().wcCameras.isOrbitCameraMode()) return;
          // 外観時には敷地選択, 外壁選択を行う
          if (ThreeView.get().wcCameras.isOrbitCameraMode()
            && !((e.selectType == webcadDefines.ExtrasSubType.GROUND) || (e.selectType == webcadDefines.ExtrasSubType.OUTWALL))) {
              return;
          }

          console.log(`選択 ${e.object.name} - 位置 ${JSON.stringify(e.point)}`);

          marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();    // 表示中の左メニューを閉じる
          const param = {
            target: e.object,
            openCallback: ThreeView.get().openDialog,
            closeCallback: ThreeView.get().closeDialog
          };

          const isStartsDialogItem = (type) => {
            // 内壁、天井、床、下がり壁 判定
            return webcadDefines.ExtrasSubType.INNERWALL || webcadDefines.ExtrasSubType.FALLINGWALL || webcadDefines.ExtrasSubType.CEILING || webcadDefines.ExtrasSubType.FLOOR;
          }

          // シェアモードでは素材・アイテムの変更を行わせないため、ダイアログを表示しない
          const isShareMode: boolean = marietta.webcad.WebCADGlobal.shareModeManager.isShareMode;

          if (e.selectType == webcadDefines.ExtrasSubType.GROUND) {
            // 見積りストの非選択
            marietta.WebCADGlobal.quotationItemList.unselectedAll();

            if (!isShareMode) {
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.TextureAndItemDialog, false, false, true, true, param);
            }
          } else if (isStartsDialogItem(e.selectType)) {
            let ua = marietta.webcad.WebCADGlobal.userAgentManager;
            if (ua.isMobile || ua.isTablet) {
              //
            }
            // 見積りストの非選択
            marietta.WebCADGlobal.quotationItemList.unselectedAll();

            // 壁・天井・床 選択時はピンの表示を強制的にONにする
            marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = true;
            marietta.webcad.WebCADGlobal.itemManager.showOrHidePin();

            //マテリアル
            param['initialMaterial'] = e.object.material.map.userData.title;

            if (!isShareMode) {
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.TextureAndItemDialogStarts, false, false, true, true, param);
            }
          }

          let changePoint: roomMaterial.ChangePointWall | roomMaterial.ChangePointCeiling | roomMaterial.ChangePointFloor = undefined;
          let guid:string;
          if (this.innerWall(e.object)) {
            // 壁のテクスチャ変更
            changePoint = new roomMaterial.ChangePointWall(e.object);
            //見積リストのハイライト表示
            marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemByIDList(changePoint.get2D(), changePoint.getTargetGuid(), 'wall');

            guid = changePoint.getTargetGuid();
          } else if (this.ceiling(e.object) || ObjectType.isGirder(e.object)) {
            // 天井のテクスチャ変更
            changePoint = new roomMaterial.ChangePointCeiling(e.object);
            //見積リストのハイライト表示
            marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(changePoint.get2D(),'ceiling');

            guid = changePoint.get2D().itemInfo.guid;
          } else if (this.floor(e.object)) {
            // 床のテクスチャ変更
            changePoint = new roomMaterial.ChangePointFloor(e.object);
            //見積リストのハイライト表示
            marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(changePoint.get2D(),'floor');
            guid = changePoint.get2D().itemInfo.guid;
          }

        const findObjectFromGUID = (guid: string): THREE.Object3D[] => {
          const objects: THREE.Object3D[] = [];
          ThreeView.get().wcScene.me.traverse((object: THREE.Object3D) => {
            if (object.userData.guid === guid || object.userData.modelInfo && object.userData.modelInfo.uuid === guid) {
              objects.push(object);
            }
          });
          console.log(`${guid} : 複数の形状で同じGUIDが割り当てられています。`);
          return objects;
        };

        //ハイライト
        if (this.innerWall(e.object)) {
          ThreeView.get().wallEffect.select(guid);
        } else if (this.ceiling(e.object) ) {
          ThreeView.get().wallEffect.select(guid, ObjectType.isCeiling);
        } else if (ObjectType.isGirder(e.object)) {
          ThreeView.get().wallEffect.select(guid, ObjectType.isGirder);
        } else {
          const objects = findObjectFromGUID(guid);
          if (objects.length > 0) {
            if (this.floor(e.object)) {
              ThreeView.get().wallEffect.select(guid, ObjectType.isMitumoriFloor);
            } else {
              ThreeView.get().selectObject(objects[0]);
            }
          }
        }


      }
      ThreeView.get().ObjectSelectManager = new ObjectSelectManager();
      ThreeView.get().ObjectSelectManager.addEventListener(webcadDefines.WebCadEventNames.selectedObject, select);
  }

  private innerWall(obj: THREE.Object3D) {
    return ObjectType.isInnerWall(obj) || ObjectType.isFallingWall(obj);
  }

  private ceiling(obj: THREE.Object3D) {
    return ObjectType.isCeiling_(obj);
  }

  private floor(obj: THREE.Object3D) {
    return ObjectType.isFloor_(obj)
  }

  //外構判定
  private site(obj: THREE.Object3D) {
    return ObjectType.isSite(obj);
  }

    public selectObject(object: THREE.Object3D) {

      ThreeView.get().unSelectedObject();

      ThreeView.get().ItemDragManager.selectObj = object;
      ThreeView.get().ItemDragManager.target = object;

      ThreeView.get().ItemDragManager.setController();
      // this.selectedObject_(object)
    }

    private showPinDialog(object: THREE.Object3D) {
      const cameraController = (flag: boolean) => {
          const wrkth = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
          (<WalkThroughCameraControl>wrkth.control)._instance.setEnabled(flag);
          // const orbit = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.orbitCamNo);
          // (<OrbitCameraControl>orbit.control)._instance.enabled = flag;
      };

      // const closeCallBack = () => {
      //     ThreeView.get().unSelectedObject();

      //     this.isOpenDialog = false;
      //     // cameraController(true);
      // };

      // const openCallback = () => {
      //     cameraController(false);
      // };

      // // 3D ダイアログにピン テキストを表示
      // const param = {
      //     guid: object.userData.modelInfo.uuid,
      //     openCallback: openCallback,
      //     closeCallback: closeCallBack

      // };
      // marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinCameraInput3DDialog, false, false, false, false, param);

      this.isOpenDialog = false;
      // ThreeView.get().cameraPinManager.createPinPicture('cameraPinPicture', ThreeView.get().container, object);

      const obj = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO)
                    .find((pin) => pin.itemInfo.guid === object.userData.modelInfo.uuid);
      const param = {
        parentObj: obj,
        view_mode:false,
      };
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinPictureInfoDialog, true, true, false, true, param);
    }

    private selectedObject_(object: THREE.Object3D, origin?: THREE.Vector3) {
        if (ThreeView.get().isPSVideoMode) return;

        // 表示中の左メニューを閉じる
        marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();

        if (ObjectType.isCameraPin(object)) {
          this.showPinDialog(object);
          return;
        }

        let canRotate = ThreeView.get().ItemDragManager.isWallItem() == false;        // 壁付けのアイテムなら回転させない
        if (ObjectType.isPin(object)) canRotate = false;           // ピンは回転させない
        let sizeIcon = ObjectType.isPin(object) == false;          // ピンはリサイズしない
        const duplicateIcon = !ObjectType.isPin(object);           // ピンは複製しない
        let textIcon = ObjectType.isPin(object) == true;           // ピンはテキストアイコンを表示する

        //
        let origin_ = origin;
        if (origin_ == null) {
            origin_ = new THREE.Vector3();
            new THREE.Box3().setFromObject(object).getCenter(origin_);
        }
        // シェアモードでは操作アイコン（移動・回転・サイズ変更・複製・削除）を表示せず、選択のみ可能とする
        if (marietta.webcad.WebCADGlobal.shareModeManager.canOperateModel) {
          ThreeView.get().pickermanager.createPicker(object, origin_, canRotate, sizeIcon, duplicateIcon, textIcon);
        }

        // 選択したBBOX作成
        ThreeView.get().BBOXSelectedManager = new BBOXManager('選択形状 BBOX', new THREE.Color(0xFF5F1F));

        // pin, camera pinは以降処理しない
        if (ObjectType.isPin(object)) return;

        if (canRotate == false) {
            //メジャーの作成
            this.measuremanager.createMeasure(object);
        }

        // アイテム変更
        // if (!object.userData.attribute) return;
        // const canSelect = object.userData.attribute.alternative && object.userData.attribute.alternative.length >= 1;

        // 表示中の左メニューを閉じる
        // if (canSelect) {
          marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
          const param: any = {};
          param.target = object;

          let targetItem: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.getItemByGuid( object.userData.modelInfo.uuid, object.userData.modelInfo.code );
          // シェアモードではアイテムの変更を行わせず、ダイアログ内のマスタ取得APIも呼ばないため表示しない
          if( !marietta.webcad.WebCADGlobal.shareModeManager.isShareMode ){
            if( marietta.webcad.WebCADGlobal.isItemForQuotation( targetItem.itemInfo.id ) ){
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ItemChangeDialogStarts, false, false, true, true, param);
            }else{
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ItemChangeDialog, false, false, true, true, param);
            }
          }
          //選択状態にする
          marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(targetItem);
        // }
    }

    public unSelectedObject() {
        ThreeView.get().controller.unSelected();                // コントローラー制御
        if (ThreeView.get().ItemDragManager) {
            ThreeView.get().ItemDragManager.resetController();      // コントローラーの削除
        }

        // 見積りストの非選択
        marietta.WebCADGlobal.quotationItemList.unselectedAll();
    }

    private unSelectedObject_() {
        ThreeView.get().pickermanager.removePicker();
        ThreeView.get().cameraPinManager.remove();

        this.measuremanager.removeMeasure();

        if (ThreeView.get().BBOXSelectedManager) {
            ThreeView.get().BBOXSelectedManager.remove();
            ThreeView.get().BBOXSelectedManager = undefined;
            this.closeRightMenu();
        }

        ThreeView.get().controller.unSelected();    // コントローラーの復帰
    }

    public closeRightMenu() {
        if (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.TextureAndItemDialog) {
            marietta.webcad.WebCADGlobal.currentDialog.close();
        }
        if (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialog) {
            marietta.webcad.WebCADGlobal.currentDialog.closeEvent();
        }
      if (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialogStarts) {
        marietta.webcad.WebCADGlobal.currentDialog.closeEvent();
      }
    }

    private deleteObject (object: THREE.Object3D) {
      new edit.DeleteObject(object).execute();
    }

    public setupModelSelect() {
        ThreeView.get().ItemDragManager = new ItemDragManager();
        ThreeView.get().ItemDragManager.enabled = false;

        const selected = (e) => {
            if (ThreeView.get().isPSVideoMode) return;

            ThreeView.get().selectedObject_(e.object, e.point);
        }

        const unSelected = () => {
            ThreeView.get().unSelectedObject_();
        }

        // 形状選択
        ThreeView.get().ItemDragManager.addEventListener(webcadDefines.WebCadEventNames.selectedObject, selected);
        // 形状非選択
        ThreeView.get().ItemDragManager.addEventListener(webcadDefines.WebCadEventNames.unSelectedObject, unSelected);
    }

    private pickerHandler(): void {
      // 削除ボタンイベント
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.deletePickerClicked, (e: any) => {
        const deleteObject = ThreeView.get().ItemDragManager.selectObj;

        if (deleteObject == null) return;

        this.closeRightMenu();

        this.isOpenDialog = true;
        marietta.webcad.WebCADGlobal.showConfirmDialog('選択アイテムを削除します\nよろしいですか？', 'アイテムの削除', () => {
            this.deleteObject(deleteObject);
            this.isOpenDialog = false;
          }, () => {
            this.isOpenDialog = false;
            ThreeView.get().unSelectedObject();
          }, true);
      });

      // サイズ変更ボタンイベント
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.sizePickerClicked, (e: any) => {
        const sizeSettingObject = ThreeView.get().ItemDragManager.selectObj;

        if (sizeSettingObject == null) return;

        this.closeRightMenu();

        const param = {
          target: sizeSettingObject,
          openCallback: ThreeView.get().openDialog,
          closeCallback: ThreeView.get().closeDialog
        };
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ItemSizeSettingDialog, false, true, true, true, param);
      });

      // アイテム複製ボタンイベント
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.duplicatePickerClicked, (e: any) => {
        new edit.DuplicateObject(e.value).execute();
        ThreeView.get().unSelectedObject();
      });

      // pin textダイアログ
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.textPickerClicked, (e: any) => {
        const object = ThreeView.get().ItemDragManager.selectObj;
        if (ObjectType.isPin(object) == false) return;

        this.isOpenDialog = true;
        const cameraController = (flag: boolean) => {
            const wrkth = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
            (<WalkThroughCameraControl>wrkth.control)._instance.setEnabled(flag);
            // const orbit = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.orbitCamNo);
            // (<OrbitCameraControl>orbit.control)._instance.enabled = flag;
        };

        const closeCallBack = () => {
            ThreeView.get().unSelectedObject();

            this.isOpenDialog = false;
            // cameraController(true);
        };

        const openCallback = () => {
            cameraController(false);
        };

        // marietta.webcad.WebCADGlobal.showPinText3D(object.userData.modelInfo.uuid);
        // 3D ダイアログにピン テキストを表示
        const param = {
            guid: object.userData.modelInfo.uuid,
            openCallback: openCallback,
            closeCallback: closeCallBack
        };
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.PinTextInput3DDialog, false, false, false, false, param);
      });
    }

    /* registItem
     * アイテムの登録.
     */
    public registItem(object: THREE.Object3D): void {
      ThreeView.get().wcItemmgr.furnitureObjects.push(<THREE.Group>(object));
      ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(object));
      marietta.view3d.base.matUtils.turnOffLights(<THREE.Group>object);
    }

    /* registSelect
     * 選択対象に登録.(画角内判定)
     */
    public registSelect(object: THREE.Object3D): void {
      ThreeView.get().wcItemmgr.addHouseData(object);
      ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
      // 画角内判定
      ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
    }

    /* setModelInfo
     * 配置後にmodelInfoに値をセット
     */
    public setModelInfo(object: THREE.Object3D, guid: string, idthreed: string, type: string, sub_type: string): void {
      object.userData.modelInfo.setTranslate(object.position.x, object.position.y, object.position.z);
      object.userData.modelInfo.setRotation(object.rotation.x, object.rotation.y, object.rotation.z);
      object.userData.modelInfo.setScale(object.scale.x, object.scale.y, object.scale.z);

      object.userData.modelInfo.reverse = false;
      object.userData.modelInfo.layer = `L${marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()))}`;
      object.userData.modelInfo.idthreed = idthreed
      object.userData.modelInfo.uuid = guid;

      object.userData.modelInfo._typeExtras = type;
      object.userData.modelInfo._subType = sub_type;
    }

    /* update2DItem
     * 2D連携：2Dアイテムの情報更新
     */
    public update2DItem(object: THREE.Object3D) {
      const partinfo: any = ThreeView.get().planmgr.autoData.autoPartsInfo(object.userData.attribute.objectId);
      const variation = {
          width: partinfo.width,
          height: partinfo.depth,
          idthreed: object.userData.modelInfo.idthreed,
          reverse: object.userData.modelInfo.reverse,
      };

      marietta.webcad.WebCADGlobal.change2Dfrom3D(object.userData.modelInfo.uuid, object.userData.modelInfo.code, variation);
    }

    /* add2DItem
     * 2D連携：アイテム追加情報更新
     */
    public add2DItem(object: THREE.Object3D, itemId: string): string {
      const extras = ThreeView.get().wcItemmgr.GltfExtras;
      const position = object.getWorldPosition(new THREE.Vector3);
      // 左下原点を左上原点に変換
      const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);
      const x = position.x * 1000 + center.x;
      const y = position.y * 1000;
      const z = position.z * 1000 + center.y;
      const rotation = THREE.MathUtils.radToDeg(VectorUtility.rotaion(object)) * -1;
      const floor = marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()));

      return marietta.webcad.WebCADGlobal.itemManager.add2Ditem(itemId, x, z, y, rotation, floor); // 2D通知
    }

    /* registerHandlers(override)
     * イベントハンドラの登録.
     */
    protected registerHandlers(): void {
      super.registerHandlers();
      this.pickerHandler();
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.mouseOver, (e) => {
        ThreeView.get().controller.pickerOver(e);
        ThreeView.get().controller.pinPictureOver(e);
      });
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.mouseOut, (e) => {
        if (ThreeView.get().isOpenDialog || ThreeView.get().isFocusText) return;
        ThreeView.get().controller.pickerOut(e);
        ThreeView.get().controller.pinPictureOut(e);
      });
      this.itemmgr.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.mouseDown, (e) => {
        ThreeView.get().controller.pickerDown(e);
      });

      // カメラが切り替わった時のイベント.
      this.cameras.eventDispatcher.addEventListener(defines.EventNames.cameraChanged, (e: any) => {
        ThreeView.get().wcScene.wcEnvironment.cameraChanged(e.value);
        marietta.webcad.WebCADGlobal.change3dMenu(e);
        ThreeView.get().unSelectedObject();             // カメラが切り替わったので形状の非選択
        ThreeView.get().controller.controllerSetUp();   // カメラが切り替わったのでコントローラの設定を行う
      });
      this.menus.eventDispatcher.addEventListener(defines.EventNames.wtPointChanged, (e: any) => {
        ThreeView.get().menus.adjustMenus(defines.EventNames.wtPointChanged);
      });
      this.menus.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.wtFloorChanged, (e: any) => {
        ThreeView.get().menus.adjustMenus(webcadDefines.WebCadEventNames.wtFloorChanged);
      });
      this.menus.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.wireframeModeChanged, (e: any) => {
        ThreeView.get().menus.adjustMenus(webcadDefines.WebCadEventNames.wireframeModeChanged);
      });
      this.menus.eventDispatcher.addEventListener(webcadDefines.WebCadEventNames.setbackModeChanged, (e: any) => {
        ThreeView.get().menus.adjustMenus(webcadDefines.WebCadEventNames.setbackModeChanged);
      });

      document.addEventListener('keydown', (e) => {
        const keycode = e.key;
        if (keycode === 'Escape' && !ThreeView.get().isOpenDialog) {
            ThreeView.get().unSelectedObject();
        }
      })
    }

    public getShowMessage() {
      // メッセージがあれば表示.
      if (this._message != '') {
        this.showMessage(webcadDefines.WebCadMessageDefs.creationFailure, this._message);
      }
    }

    /* showMessage
     * メッセージの表示.
     */
    public showMessage(mainMessage: string, subMessage: string): void {
      const messages = mesUtils.get(mainMessage).split(webcadDefines.GlobalDefs.msgDelim);
      const subtexts = [];
      const cpl = 18;
      subMessage.trim();
      const subMessages = mesUtils.get(subMessage).split(webcadDefines.GlobalDefs.msgDelim);
      for (let i = 0; i < subMessages.length; i++) {
        const lines = subMessages[i].length / cpl;
        for (let j = 0; j < lines; j++) {
          subtexts.push(subMessages[i].substring(j * cpl, Math.min(subMessages[i].length, (j + 1) * cpl)));
        }
      }
      this.wcItemmgr.createMessage(MessageType.Alert, messages, subtexts);
      this.wcItemmgr.showMessage();
    }

    /* resetScene
     * 旧データのクリーンアップ.
     */
    public resetScene(): void {
      this._message = '';
      this.resetOpacity(false);

      const options: defines.Options = new defines.Options({
        minus: [
          defines.ResetOptions.deleteCameras,
          defines.ResetOptions.resetEnv,
          defines.ResetOptions.resetRenderer,
          webcadDefines.WebCadResetOptions.resetPartMaterials],
      });
      this.reset(options);

      this.pickermanager.removePicker();
      this.cameraPinManager.remove();

      this.measuremanager.removeMeasure();

      if (!this.BBOXSelectedManager) return;
      this.BBOXSelectedManager.remove();
      this.BBOXSelectedManager = undefined;
    }

    /* resetOpacity
    * 画面の透明度をリセット.
    */
    public resetOpacity(visible: boolean): void {
      this.container.style.opacity = String(visible ? 1.0 : webcadDefines.WebCadCameraDefs.containerInitOpacity);
    }

    /* reset
     * 旧データのクリーンアップ.
     */
    public reset(options: defines.Options): void {
      super.reset(options);

      this.matmgr.reset(options);
      this.menus.reset(options);

      this.toDayTime(true);

      View3dGlobal.shared.reset();
    }

    public pscamerasetup(): void {
        const isNaikan = ThreeView.get().cameras.isWalkThroughCameraMode();
        const exposer = isNaikan ? 10.0 : 7.0;        //露出

        const autoexposure = new pscommand.autoexposure(exposer).object();
        ThreeView.get().pscommunication.send(autoexposure);

        new PSSceneManagement().sendCamera();
    }

    public updateObject(object: THREE.Object3D) {
        if (!ObjectType.isPin(object)) {
            new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).update(); // extras更新
        }

        const { x, y, z, rotation } = this.get2DPlacement(object);

        const item: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(object.userData.modelInfo.uuid);
        const beforeDepth: number = item?.itemInfo.depth;
        marietta.webcad.WebCADGlobal.itemManager.update2Ditem(object.userData.modelInfo.uuid, x, z, y, rotation); // 2D通知
        // 別の部屋へ動かした UB は 2D で天井高さに合わせ直すので、3D のモデルの高さも揃える
        if (item && item.itemInfo.depth !== beforeDepth) {
            this.fitHeightTo2D(object, item);
        }
    }

    /* fitHeightTo2D
     * 3D のモデルの縦の大きさを、2D の高さ（itemInfo.depth）に合わせる
     */
    public fitHeightTo2D(object: THREE.Object3D, item: marietta.webcad.item.MonicaObject): void {
        const MM_PER_METER = 1000;
        // ItemScale.setScale と同じく、obb は拡縮前の大きさ
        const size: THREE.Vector3 = object.userData.obb.obb.getSize(new THREE.Vector3());
        if (size.y === 0) {
            return;
        }
        object.scale.y = item.itemInfo.depth / Math.abs(size.y * MM_PER_METER);

        new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).update(); // extras更新
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        // 画角内判定
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
    }

    public updateScale(object: THREE.Object3D) {
      new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).update(); // extras更新

      const { widthmm, heightmm, depthmm } = this.get2DSize(object);
      marietta.webcad.WebCADGlobal.itemManager.update2Ditem(object.userData.modelInfo.uuid, null, null, null, null, widthmm, depthmm, heightmm); // 2D通知
  }

    /* updateScaleAndPosition
     * 2D連携：サイズと位置を1回で通知する（履歴を1件にするため）
     */
    public updateScaleAndPosition(object: THREE.Object3D): void {
      new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, object).update(); // extras更新

      const { x, y, z, rotation } = this.get2DPlacement(object);
      const { widthmm, heightmm, depthmm } = this.get2DSize(object);
      marietta.webcad.WebCADGlobal.itemManager.update2Ditem(object.userData.modelInfo.uuid, x, z, y, rotation, widthmm, depthmm, heightmm); // 2D通知
    }

    /**
     * 3Dの位置を2D連携用の座標(mm)と回転角に変換する。y は高さ
     */
    private get2DPlacement(object: THREE.Object3D): { x: number, y: number, z: number, rotation: number } {
      const extras = ThreeView.get().wcItemmgr.GltfExtras;
      const position = object.getWorldPosition(new THREE.Vector3);
      // 左下原点を左上原点に変換
      const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);
      return {
        x: position.x * MM_PER_M + center.x,
        y: position.y * MM_PER_M,
        z: position.z * MM_PER_M + center.y,
        rotation: THREE.MathUtils.radToDeg(VectorUtility.rotaion(object)) * -1,
      };
    }

    /**
     * スケール込みの3Dサイズを mm で返す
     * 倍率を掛け戻すと 99.99999… のような誤差が出るため、サイズ設定と同じ mm の整数に丸める
     */
    private get2DSize(object: THREE.Object3D): { widthmm: number, heightmm: number, depthmm: number } {
      const { scale } = object;
      const size = object.userData.obb.obb.getSize(new THREE.Vector3());
      return {
        widthmm: Math.round(size.x * MM_PER_M * scale.x),
        heightmm: Math.round(size.y * MM_PER_M * scale.y),
        depthmm: Math.round(size.z * MM_PER_M * scale.z),
      };
    }

    /* setupAuto
     * オート処理インスタンスのセットアップ.
     */
    public setupAuto(autoMain: marietta3d.manager.AutoMain): void {
      this._planmgr = autoMain;

      // マテリアルの初期化
      this._planmgr.initMaterials();
    //   this.matmgr.initMaterials(this.planmgr);
    }

    /* exitToNormal
     * ビジー表示から抜ける.
     */
    public exitToNormal() {
        marietta.webcad.WebCADGlobal.hideBusy();
        if (this.eventDispatcher == null) return;
        this.eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.loadingTexFinished);
    }

    /* getWarningMessage
     * メッセージ情報を取得.
     */
    public getWarningMessage(data: HTMLElement): any {
      let str = mesUtils.getMessage(data.getElementsByTagName('message'));
      if ((str != undefined) && (str.replace != undefined)) {
        str = str.replace(/(^\s+)|(\s+$)/g, '').replace(/\r?\n/g, '');
        this._message = str;
      }
      return undefined;
    }

    /* showFloor
     * 階表示の制御.
     */
    public showFloor(floor: number, visible: boolean): void {
      if (this.cameras.no == defines.CameraDefs.orbitCamNo) {
        this.wcItemmgr.showFloor(floor, visible);
        this.wcCameras.tweenTo(this.wcCameras, floor, this.wcItemmgr.sizesObjects.visible);
      }
    }

    /* resetFloorShow
     * 各階表示を初期化する.
     */
    public resetFloorShow(): void {
      this.wcItemmgr.showFloor(webcadDefines.Limits.roofNo, true);
      this.menus.adjustMenus(webcadDefines.WebCadEventNames.obFloorVisChanged);
    }

    /* levitateTo
    * 階表示の制御.
    */
    public levitateTo(floor: number): void {
      if (this.cameras.no == defines.CameraDefs.wlkthCamNo) {
        this.wcCameras.levitation(this.wcCameras, floor);
      }
    }

    /* toggleMesureLines
     * 寸法線の表示非表示.
     */
    public toggleMesureLines(): void {
      this.wcItemmgr.sizesObjects.visible = !this.wcItemmgr.sizesObjects.visible;
      this.eventDispatcher.dispatchEvent(webcadDefines.WebCadEventNames.sizeObjectVisible);
    }

    /* toggleWireframes
     * ワイヤフレームの表示非表示.
     */
    public toggleWireframes(): void {
      this.wcItemmgr.wireframe = !this.wcItemmgr.wireframe;
    }

    /* toggleSetbacks
     * 斜線規制の表示非表示.
     */
    public toggleSetbacks(): void {
      this.wcItemmgr.setbackObjects.visible = !this.wcItemmgr.setbackObjects.visible;
    }

    /* setAnimations
     * アニメーションのセット.
     */
    public setAnimations(wtAnim: WalkThroughAnimation): void {
      const wtAnimCtrl: any = (this.cameras.getCamera(defines.CameraDefs.wlkthCamNo).getNavigator(webcadcamera.WebCadWalkThroughAnimationControl, this.eventDispatcher));
      wtAnimCtrl.add(wtAnim);
    }

    /* toDayTime
     */
    public toDayTime(immediate?: boolean): void {
      if (this.matmgr != undefined) {
        this.wcItemmgr.setForTime(12, this.matmgr, immediate);
      }
    }

    /* toNightTime
     */
    public toNightTime(immediate?: boolean): void {
      if (this.matmgr != undefined) {
        this.wcItemmgr.setForTime(0, this.matmgr, immediate);
      }
    }

    /* hiliteName
     * 指定の名前の形状をハイライト表示.
     */
    public hiliteName(name?: string): void {
      ;
    }

    /* hiliteMaterial
     * 指定の材質を持つ形状をハイライト表示.
     */
    public hiliteMaterial(name?: string): void {
      ;
    }

    // スクリーンショットをキャプチャ
    public saveViewAsImage() {
      this.wcRenderer.render(this.scene, this.cameras.camera);
      this.saveImage(`${marietta.webcad.WebCADGlobal.APP_NAME}_${getFormattedTime()}.jpg`);
      // 日付と時刻をフォーマットする
      function getFormattedTime() {
        const today = new Date();
        const y = today.getFullYear();
        // JavaScript months are 0-based.
        const m = today.getMonth() + 1;
        const d = today.getDate();
        const h = today.getHours();
        const mi = today.getMinutes();
        const s = today.getSeconds();
        return `${y}-${m}-${d}_${h}-${mi}-${s}`;
      }
    }

    // 見ている３Dビューを画像としてダウンロードする
    private saveImage(filename) {
      try {
        marietta.webcad.WebCADGlobal.showBusy();
        const imgData = this.renderer.me.domElement.toDataURL('image/jpeg', 0.9);
        this.sentImage(imgData, filename);
      } catch (e) {
        // 画像の取り出しに失敗したときにビジー表示が残らないようにする
        console.log(e);
        marietta.webcad.WebCADGlobal.hideBusy();
      }
    }

    /**
     *
     * パース図保存API
     */
    public sentImage(imgData, fileName) {
      // シェアモードではサーバーに保存せず、ローカル保存のみ行う
      if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
        this.saveFile(imgData, fileName);
        marietta.webcad.WebCADGlobal.hideBusy();
        return;
      }

      try {
        const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.persepective_image_api_url}`;
        const image64 = ThreeView.get().get3DImageData();
        const imageUrl = image64;
        fetch(imageUrl)
          .then(res => res.blob())
          .then(blob => {
            const datetime = new Date();
            const date = new Date().toISOString().slice(0, 10).split('-')
              .map((d) => parseInt(d, 10))
              .join('');
            const name = `plan_image_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.png`;
            let file = new File([blob], name, {
              type: 'image/png'
            });
            const formData = new FormData();
            formData.append('image', file);
            formData.append('operation_type', marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type.toString());
            const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;
            const self = this;
            const headers = {
              Authorization: token,
              Accept: 'application/json',
            };
            fetch(url, {
              method: 'POST',
              body: formData,
              headers,
            }).then((response) => {
              if (response.status >= 200 && response.status <= 299) {
                return response.json();
              } else if (response.status == 400) {
                return response.json();
              }
              throw Error(response.statusText);
            }).then((info) => {
              // ログイン済み
              if (info.errors === undefined) {
                // HideBusy
                marietta.webcad.WebCADGlobal.hideBusy();
                // 保存しましたダイアログを表示する
                marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_PERSPECTIVE_SAVE_SUCCESS'));

              } else {
                // HideBusy
                marietta.webcad.WebCADGlobal.hideBusy();
                if (info.errors.message.length > 0) {
                  marietta.webcad.WebCADGlobal.showAlert(info.errors.message[0]);
                } else {
                  marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_PERSPECTIVE_SAVE_ERROR'));
                }
              }
              this.saveFile(imgData, fileName);
            }).catch(() => {
              marietta.webcad.WebCADGlobal.hideBusy();
              marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_PERSPECTIVE_SAVE_ERROR'));
              this.saveFile(imgData, fileName);
            });
          });
      } catch (e) {
        marietta.webcad.WebCADGlobal.hideBusy();
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_PERSPECTIVE_SAVE_ERROR'));
        this.saveFile(imgData, fileName);
      }
    }

    private saveFile(strData: any, filename: string) {
      if (typeof document === 'undefined') return;

      const link: any = document.createElement('a');
      if (typeof link.download !== 'string') {
        location.replace(strData);
        return;
      }

      // iOSはdata URLのダウンロードが不安定なため、Blobに変換して渡す
      const url: string = URL.createObjectURL(marietta.webcad.util.WebCADUtil.dataURItoBlob(strData));
      link.download = filename;
      link.href = url;
      document.body.appendChild(link); // Firefox requires the link to be in the body
      link.click();
      document.body.removeChild(link); // remove the link when done

      // ダウンロードの開始前に無効化されないよう、少し待ってから解放する
      window.setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_MS);
    }

    public export_gltf() {
        new ExportGLTF().export();
    }

    public export_collada() {
        new ExportCollada().export();
    }

    // ファイルエクスポート
    public export_file(data: any, filename: string, fileType: string) {
      const link = document.createElement( 'a' );
      link.style.display = 'none';
      document.body.appendChild( link ); // Firefox workaround, see #6594

      const save = ( blob, filename ) => {
          link.href = URL.createObjectURL( blob );
          link.download = filename;
          link.click();
      }
      save(new Blob([data], {type: fileType}), filename);
    }

    // glb (サーバーからきた建物データ)
    public export_glb() {
      this.export_file(ThreeView.get().wcItemmgr.BinaryData, 'scene.glb', 'application/octet-stream');
    }

    // scene extas
    public export_extras() {
      this.export_file(JSON.stringify(ThreeView.get().wcItemmgr.GltfExtras), 'scene_extras.json', 'application/json');
    }


    // LiDAR
    public importLiDAR() {
      // 連続して同じファイルを選択できるように初期化
      (<HTMLInputElement>document.getElementById('filePickerLiDAR')).value = null;
      document.getElementById('filePickerLiDAR').click();
    }

    // LiDARファイルの読み込み
    public importLiDARFile(e) {
      console.log('file import');
      // 3D内観カメラ情報の初期化しておく
      // marietta.view3d.webcad.View3dGlobal.shared.clearCameraState();

      const file = e.target.files[0];
      const reader = new FileReader();

      reader.addEventListener('load', (event) => {
        const text: string = (event.target as FileReader).result as string;
        const p = new Promise((resolve: Function) => {
          // json parse
          const JSONParse = Convert.toJSONParse(text);
          resolve(JSONParse);
        });
        p.then((res: JSONParse) => {
          console.log(res);
          // new LoadJSON(res).execute();
          // UB の高さを初期値に
          LiDARUnitBath.applyToRawData(res);
          this.LidarManager = new LoadJSON(res);
          this.LidarManager.execute();
          // UB の高さを部屋の天井高さに
          LiDARUnitBath.fitToCeiling();
          marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        }).catch((msg: any) => {
          console.log(msg);
        });
      });
      reader.readAsText(file, 'utf-8');
    }

    /**
     * フォーマット変更
     */
    public changeFormat(e) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.addEventListener('load', (event) => {
        const text: string = (event.target as FileReader).result as string;
        let object;
        if (object.application.customize === 'LiDAR APP') {
          // STARTSのフォーマットに変更
          object = new WebViewData().execute(JSON.parse(text));
        } else {
          object = JSON.parse(text);
        }
        console.log(object);

        const p = new Promise((resolve: Function) => {
          marietta.webcad.util.WebcadJSONParser.reproduceWebCAD(JSON.stringify(object), false, true, resolve);
        });
        p.then(() => {
          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
            marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
          }
          marietta.webcad.WebCADGlobal.webcad2Dmanager.resetHistory();
          marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();
          marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
          marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
          marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
          marietta.webcad.WebCADGlobal.quotationItemList.createData();
          // 見積リストの所属部屋名を更新する
          marietta.webcad.WebCADGlobal.quotationItemList.updateRoomTextForAllTables();

          marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
          marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode(true);

          /** 部屋指定ウィザード・ピン指定ウィザード */
          ThreeView.get().selectWizard();

        }).catch((msg: any) => {
          console.log(msg);
        });

      });
      reader.readAsText(file, 'utf-8');
    }

    // 部屋指定ウィザード・ピン指定ウィザード
    public selectWizard() {

      ThreeView.get().wizardManager = new WizardManager();

      // 部屋入力チェック・ピン入力チェック
      if (!ThreeView.get().wizardManager.hasWizardItem()) {
        console.log('部屋の入力、および紐づけるピンが存在しない');
        ThreeView.get().wizardManager.end();
        return;
      }

      // // ピンの紐づけ開始
      // marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('LINK_PIN_ITEM'));

      // ウィザードの開始
      ThreeView.get().wizardManager.start();

    }

    /**
     * 3Dキャプチャー
     * @returns
     */
    public get3DImageData() {
      let imgData = this.renderer.me.domElement.toDataURL();
      return imgData;
    }
}
